module.exports = __webpack_public_path__ + "static/all-1.0.0.jpeg";